import KunLoading19 from './src/index'

KunLoading19.install = function (Vue) {
	Vue.component(KunLoading19.name, KunLoading19);
}

export default KunLoading19;
